import { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { AiOutlineFilter } from "react-icons/ai";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";

import { approverType } from "../../../../constants";

import { Table, UserManual } from "../../../../components";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import { ExportFileExcel } from "../components";
import moment, { Moment } from "moment";
import { compareRequestStatus, getRequestStatusHasAssigneeOptions } from "../../utils";
import { requestStatusTypes } from "../types";
import { getStatusBaseOnApprover, getStepBaseOnApprover } from "../delete-user-account/utils";
import { useUser } from "../../../../hook";
import { useCodeProcessColumns } from "./hooks/use-code-process-column";
import { useCodeProcessRequests } from "./hooks";
import CreateRequestButton from "../../components/CreateRequestButton";

export const procedureProcessVms: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { email } = useUser();
  const { columns } = useCodeProcessColumns();
  const {
    mappedCodeProcessMyRequests,
    mappedCodeProcessRequests2 = [],
    isLoading,
    guideLink,
  } = useCodeProcessRequests();

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedCodeProcessRequests2];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedCodeProcessRequests2]);

  const requestStatusOptions = getRequestStatusHasAssigneeOptions("Đã cấp mới");

  const flattedData = mappedCodeProcessRequests2.map((record: any) => {
    const status = getStatusBaseOnApprover(record, email);
    const step = getStepBaseOnApprover(record, email);

    const requestStatus =
      status === requestStatusTypes.submitted && step === approverType.assignee
        ? requestStatusTypes.submittedAssignee
        : record.eRequestStatus;

    return {
      id: record.id,
      createdDateTime: getDDMMYYYFormat(record.createdDateTime),
      eRequestStatus: record.eRequestStatus,
      eRequestPersonName: record.createdByName,
      eRequestType: record.eRequestType === "provide" ? "Cấp mới" : "Thay đổi",
      ePhoneNumber: record.ePhoneNumber,
      eDepartment: record.eDepartment,
      eUnit: record.eUnit,
      eDescription: record.eDescription,
      eRequestStatusText: requestStatusOptions.find((e) => e.value === requestStatus)?.label,
    };
  });

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <UserManual title="CẤP QUYỀN SỬ DỤNG CHƯƠNG TRÌNH" icon={<Icon.CodeBoxLine />} guideLink={guideLink} />
        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton
              onClick={() => history.push(Routes.createProcessCodeVmsNewPage.path.replace(":id", "0"))}
            />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            scroll={{ x: 1100 }}
            dataSource={mappedCodeProcessMyRequests}
            onRow={(record) => ({
              onClick: () => history.push(Routes.processCodeGrantedDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportFileExcel
              exportContent={{
                fileName: "Danh sach yeu cau can duyet cap quyen SD chuong trinh Viags",
                content: [
                  { header: "Mã yêu cầu", dataIndex: "id" },
                  { header: "Yêu cầu", dataIndex: "eRequestType" },
                  { header: "Người yêu cầu", dataIndex: "eRequestPersonName" },
                  { header: "SĐT Người yêu cầu", dataIndex: "ePhoneNumber" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "Đơn vị", dataIndex: "eUnit" },
                  { header: "Mô tả", dataIndex: "eDescription" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              initialValues={filters}
              requestStatusOptions={requestStatusOptions}
              onChange={(_, allValues: any) => setFilters(allValues)}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportFileExcel>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            scroll={{ x: 1100 }}
            columns={columns}
            dataSource={filteredDataSource}
            onRow={(record) => ({
              onClick: () => history.push(Routes.processCodeGrantedDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
